<div class="container-fluid p-0">
	<div class="row">
		<div
			class="col-xl-7"
			[ngStyle]="{
				'background-image': 'url(./assets/images/login/1.jpg)',
				'background-size': 'cover',
				'background-position': 'center center',
				display: 'block'
			}"
		>
			<img class="bg-img-cover bg-center d-none" src="./assets/images/login/1.jpg" alt="looginpage" />
		</div>
		<div class="col-xl-5 p-0">
			<div class="login-card">
				<div>
					<div>
						<a class="logo" routerLink="/">
							<img
								class="img-fluid for-light"
								src="./assets/images/logo/Tasyire-logo.png"
								alt="looginpage"
							/>
							<img
								class="img-fluid for-dark"
								src="./assets/images/logo/Tasyire-logo.png"
								alt="looginpage"
							/>
						</a>
					</div>
					<div class="login-main">
						<form class="theme-form" [formGroup]="registrationForm" (ngSubmit)="registration()">
							<h4 translate>Create your account</h4>
							<p>{{ 'Enter your personal details to create account' | translate }}</p>
							<div class="form-group">
								<label class="col-form-label pt-0">{{ 'Your Name' | translate }}</label>
								<div class="row">
									<div class="col-6">
										<input
											class="form-control"
											type="text"
											required
											id="firstName"
											name="firstName"
											placeholder="{{ 'First name' | translate }}"
											formControlName="firstName"
										/>
									</div>
									<div class="col-6">
										<input
											class="form-control"
											type="text"
											required
											id="lastName"
											name="lastName"
											placeholder="{{ 'Last name' | translate }}"
											formControlName="lastName"
										/>
									</div>
								</div>
							</div>
							<div class="form-group">
								<label class="col-form-label" translate>Username</label>
								<input
									class="form-control"
									type="text"
									required
									id="username"
									name="username"
									placeholder="{{ 'username' | translate }}"
									formControlName="username"
								/>
								<span *ngIf="usernameError" class="text-danger">
									{{ usernameError | translate }}
								</span>
							</div>
							<div class="form-group">
								<label class="col-form-label" translate>Email Address</label>
								<input
									class="form-control"
									type="email"
									required
									id="email"
									name="email"
									placeholder="example@yourmail.com"
									formControlName="email"
								/>
								<span *ngIf="emailError" class="text-danger">
									{{ emailError | translate }}
								</span>
							</div>
							<div class="form-group">
								<label class="col-form-label" translate>Phone Number</label>
								<input
									class="form-control"
									type="text"
									id="phone"
									name="phone"
									placeholder="06 xx xx xx xx"
									formControlName="phoneNumber"
									dir="ltr"
									required
								/>
								<span
									class="text-danger"
									*ngIf="phoneNumber?.touched && phoneNumber?.errors?.['required']"
								>
									{{ 'Phone number is required' | translate }}
								</span>
								<span
									class="text-danger"
									*ngIf="phoneNumber?.touched && phoneNumber?.errors?.['pattern']"
								>
									{{ 'Phone number is invalid' | translate }}
								</span>
							</div>
							<div class="form-group">
								<label class="col-form-label">Password</label>
								<input
									class="form-control"
									[type]="show ? 'text' : 'password'"
									name="login[password]"
									required
									placeholder="*********"
									id="password"
									formControlName="password"
									(input)="validatePassword()"
								/>
								<div
									[ngClass]="[selectedLang.code === 'ar' ? 'hide-left' : 'hide-right']"
									(click)="show = !show"
									*ngIf="!show"
								>
									<span class="show"></span>
								</div>
								<div
									[ngClass]="[selectedLang.code === 'ar' ? 'hide-left' : 'hide-right']"
									(click)="show = !show"
									*ngIf="show"
								>
									<span class="Hide"></span>
								</div>
								<span *ngIf="passwordError" class="text-danger">
									{{ passwordError | translate }}
								</span>
							</div>
							<div class="form-group mb-0">
								<div
									class="alert alert-danger d-flex align-items-center"
									role="alert"
									*ngIf="errorMessage && !successMessage"
								>
									<i class="fa fa-warning fa-x2"></i>
									<div>
										{{ errorMessage | translate }}
									</div>
								</div>
								<div
									class="alert alert-success d-flex align-items-center"
									role="alert"
									*ngIf="successMessage && !errorMessage"
								>
									<i class="fa fa-check-circle fa-x2"></i>
									<div>
										{{ successMessage | translate }}
									</div>
								</div>
								<button class="btn btn-primary d-block w-100" type="submit">
									{{ 'Create Account' | translate }}
								</button>
								<!--								<div class="mt-3">-->
								<!--									<asl-google-signin-button type="standard" size="large" text="signup_with">-->
								<!--									</asl-google-signin-button>-->
								<!--								</div>-->
							</div>
							<p class="mt-4 mb-0">
								{{ 'Already have an account ?' | translate
								}}<a class="ms-2" [routerLink]="'../login'">{{ 'Sign in' | translate }}</a>
							</p>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
